import React from 'react';
import { RouteComponentProps } from 'react-router';
import { AccountConfirmationContainer } from '../../containers';

const AccountConfirmationPage = ({ match }: Props) => <AccountConfirmationContainer token={match.params.token} />;

export default AccountConfirmationPage;

interface IOwnProps {
    token: string;
}

type Props = RouteComponentProps<IOwnProps>;
